import axios from 'axios'
import Video from '../../models/Video'
import QPVInteractiveMapper from './QPVInteractiveMapper'
import QPVChaptersMapper from './QPVChaptersMapper';
import { QPVSlidesMapper } from '@/repositories/QPV/QPVSlidesMapper';
import {srt2webvtt} from "../../utils/strToVttConverter";

class QPVRepository {
  async getVideoById(config) {
    var params = {
      crossdomain: true,
      headers: {
        Authorization: 'Bearer ' + config.token,
        'X-Referer': this._getXRefererDomain(config.referrer)
      }
    }
    this.response = (await axios.get(process.env.VUE_APP_API_HOST + '/player-api/videos/' + config.videoId, params)).data
    var playerTemplate = await this._getPlayerTemplate();

    return new Video({
      image: this.response.thumbnail,
      sourceURL: this.response.playlist_url ? this.response.playlist_url : this.response.source_url,
      platformVideoId: this.response.id,
      libraryId: this.response.library,
      companyId: this.response.company || undefined,
      subtitleFiles: await this._convertSubtitlesToVtt(),
      title: this.response.title,
      description: this.response.description || '',
      templateData: playerTemplate
    })
  }

  _getXRefererDomain(xReferer) {
    const url = new URL(xReferer);
    if (!url.hostname) {
      // weird, but it could happen
      return xReferer;
    }
    return url.hostname;
  }

  async _getPlayerTemplate() {
    var playerTemplateApiUrl = process.env.VUE_APP_API_HOST + `/player-template-player-api/player-template-for-video/${this.response.library}/${this.response.player_template_id || ''}`;
    try {
      return (await axios.get(playerTemplateApiUrl).then()).data;
    } catch (err) {
      return {};
    }
  }

  getChapters() {
    return new Promise((resolve) => {
      const chapters = (new QPVChaptersMapper(this.response)).map();
      resolve(chapters);
    });
  }

  /**
   * @return []InteractiveItem
   */
  getInteractiveArea() {
    return new Promise((resolve) => {
      let interactiveElements = (this.response.interactive_area || []).map(function (raw) {
        return QPVInteractiveMapper.map(raw)
      })
      resolve(interactiveElements)
    })
  }

  /**
   * @return []Slide
   */
  getSlides() {
    return new Promise((resolve) => {
      resolve(new QPVSlidesMapper(this.response).map());
    })
  }

  async _convertSubtitlesToVtt() {

    let subtitles = this.response.subtitles || [];

    for (let i = 0; i < subtitles.length; i++) {
      let subtitleFile = subtitles[i];
      if (subtitleFile.name.indexOf('.srt') === -1) {
        continue;
      }
      let subtitleResponse = await axios.get(subtitleFile.url);
      let vttText = srt2webvtt(subtitleResponse.data);
      var vttBlob = new Blob([vttText], {type : 'text/vtt'});
      subtitles[i].blobUrl = URL.createObjectURL(vttBlob);
    }

    return subtitles;
  }
}

export default QPVRepository;
